import { GET, PUT } from '../request'

export const getLead = id => GET('/api/profes/marketing/feedback', { id })

export const addValoracionPrueba = ({ id, fecha, hora, valoracion }) =>
  PUT('/api/profes/marketing/feedback/valorar-prueba', {
    id,
    fecha,
    hora,
    valoracion
  })
